export enum ListingTypesEnum {
    List = 'list',
    Grid = 'grid',
    Lifestyle = 'lifestyle',
    Default = 'default'
}

export type ListingType = 'grid' | 'list' | 'lifestyle' | 'default';

export interface CategoryListingConfig {
    type: 'listing';
    config: {
        listingType: ListingType;
        listingCount: number;
    };
}
